/**
 * My Games state slice
 */
export const myGamesSlice = {
    latestMoves: [],  // [{ move, total, wins, draws, losses }]
    plans: [],        // [{ moves: [uci...], total, wins, draws, losses }]
    moveDiffs: [],    // [{ move(uci), diff, myWinPct, sparringWinPct }] - per-move comparison vs sparring DB
    fen: null,        // FEN at which latestMoves were loaded (for UCI→SAN conversion)
    isLoading: false,
    error: null,      // null | 'notLoggedIn'
    stats: null,      // { total, wins, draws, losses, winPct, drawPct, lossPct }
};
